export const LEAD_MANAGEMENT_PAGESZ = 10;
